/* Controlled Hands theme helpers: product variant cards, gallery, sticky add-to-basket bar. No dependencies. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Gallery ---------- */
  if (!customElements.get('ch-gallery')) {
    customElements.define(
      'ch-gallery',
      class CHGallery extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-ch-viewport]');
          if (!this.viewport) return;
          this.slides = Array.from(this.viewport.children);
          this.thumbs = Array.from(this.querySelectorAll('[data-ch-thumb]'));
          this.dots = Array.from(this.querySelectorAll('.ch-gallery__dot'));
          this.thumbs.forEach((thumb) =>
            thumb.addEventListener('click', () => this.goToIndex(Number(thumb.dataset.chThumb)))
          );
          let ticking = false;
          this.viewport.addEventListener(
            'scroll',
            () => {
              if (ticking) return;
              ticking = true;
              requestAnimationFrame(() => {
                const w = this.viewport.clientWidth || 1;
                this.setActive(Math.round(this.viewport.scrollLeft / w));
                ticking = false;
              });
            },
            { passive: true }
          );
          this.viewport.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') this.goToIndex(this.index + 1);
            if (e.key === 'ArrowLeft') this.goToIndex(this.index - 1);
          });
          this.index = 0;
        }

        goToIndex(i) {
          if (!this.slides || !this.slides.length) return;
          const index = Math.max(0, Math.min(this.slides.length - 1, i));
          this.viewport.scrollTo({
            left: this.slides[index].offsetLeft - this.viewport.offsetLeft,
            behavior: reduceMotion ? 'auto' : 'smooth',
          });
          this.setActive(index);
        }

        goToMedia(mediaId) {
          if (!mediaId || !this.slides) return;
          const i = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
          if (i > -1) this.goToIndex(i);
        }

        setActive(i) {
          if (i === this.index) return;
          this.index = i;
          this.thumbs.forEach((t, n) =>
            n === i ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current')
          );
          this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
        }
      }
    );
  }

  /* ---------- Product (variant cards + live price + sticky bar) ---------- */
  if (!customElements.get('ch-product')) {
    customElements.define(
      'ch-product',
      class CHProduct extends HTMLElement {
        connectedCallback() {
          const data = this.querySelector('[data-ch-variants]');
          this.variants = data ? JSON.parse(data.textContent) : [];
          this.idInput = this.querySelector('#ch-product-form [name="id"]');
          this.gallery = this.querySelector('ch-gallery');

          this.addEventListener('change', (e) => {
            if (e.target.classList && e.target.classList.contains('ch-variant__input')) this.select(e.target.value);
          });

          const current = this.idInput && this.variants.find((v) => String(v.id) === this.idInput.value);
          if (current) this.render(current);

          this.initSticky();
        }

        select(id) {
          const variant = this.variants.find((v) => String(v.id) === String(id));
          if (!variant) return;
          if (this.idInput) this.idInput.value = variant.id;
          this.render(variant);
          if (this.dataset.updateUrl === 'true') {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          }
          if (variant.media && this.gallery) this.gallery.goToMedia(variant.media);
          document.dispatchEvent(new CustomEvent('ch:variant-change', { detail: { variant } }));
        }

        render(variant) {
          document.querySelectorAll('[data-ch-live-price]').forEach((el) => (el.textContent = variant.price));
          document.querySelectorAll('[data-ch-variant-title]').forEach((el) => (el.textContent = variant.title));
          document.querySelectorAll('[data-ch-atc]').forEach((btn) => {
            btn.disabled = !variant.available;
          });
          const label = this.querySelector('[data-ch-atc-label]');
          if (label) label.textContent = variant.available ? this.dataset.atcLabel : this.dataset.soldOut;
          const priceWrap = this.querySelector('[data-ch-price-wrap]');
          if (priceWrap) priceWrap.hidden = !variant.available;
        }

        initSticky() {
          const bar = this.querySelector('[data-ch-sticky]');
          const main = this.querySelector('#ch-main-atc');
          if (!bar || !main) return;
          const mq = window.matchMedia('(max-width: 749px)');
          let shown = null;
          let ticking = false;
          const update = () => {
            ticking = false;
            const visible = mq.matches && main.getBoundingClientRect().bottom < 0;
            if (visible === shown) return;
            shown = visible;
            bar.classList.toggle('is-visible', visible);
            document.body.classList.toggle('ch-sticky-active', visible);
            if (visible) bar.removeAttribute('inert');
            else bar.setAttribute('inert', '');
          };
          const onScroll = () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(update);
          };
          window.addEventListener('scroll', onScroll, { passive: true });
          window.addEventListener('resize', onScroll, { passive: true });
          update();
        }
      }
    );
  }
})();

/* Accordions that should start closed on mobile */
(() => {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  const run = () => document.querySelectorAll('details[data-ch-close-mobile]').forEach((d) => d.removeAttribute('open'));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
